// NOTE: '¡' puts everything after the default suggestions provided by Monaco
// (which are usually fewer and more context appropriate)
const SORT_TEXT_PREFIX = '¡'

/**
 * Mostly corresponds to a {@link monaco.languages.CompletionItem}, but set up
 * in a way that allows it to be instantiated ahead of time and applied as a
 * specific edit later through {@link Snippet.appliedTo}
 */
export class Snippet {
  constructor(
    /**
     * Used by {@link appliedTo}
     */
    private readonly _getCompletionItem: (
      context: Snippet.Context,
    ) => monaco.languages.CompletionItem | undefined,
  ) {}

  /**
   * Creates a {@link monaco.languages.CompletionItem} based on the given
   * {@link Snippet.Context}
   *
   * Returns `undefined` if a {@link monaco.languages.CompletionItem} is not
   * applicable with the given {@link Snippet.Context}
   */
  public appliedTo(
    context: Snippet.Context,
  ): monaco.languages.CompletionItem | undefined {
    const completionItem = this._getCompletionItem(context)
    if (!completionItem) {
      return
    }
    const label =
      typeof completionItem.label === 'string'
        ? completionItem.label
        : completionItem.label.label
    return {
      ...completionItem,
      sortText: `${SORT_TEXT_PREFIX}${completionItem.sortText ?? label}`,
    }
  }
}
export namespace Snippet {
  /**
   * Represents information about the state of the editor when this
   * {@link Snippet} is being triggered
   */
  export interface Context extends monaco.languages.CompletionContext {
    readonly model: monaco.editor.ITextModel
    readonly position: monaco.Position
    readonly word: monaco.editor.IWordAtPosition
    readonly range: monaco.IRange
  }
}
